var _style, _path, _path2, _g, _g2, _g3, _polyline, _polyline2, _polyline3, _g4, _polyline4, _g5, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:none;stroke:#5B5B5B;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#5B5B5B;stroke-width:1.2;stroke-linecap:round;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "options") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,0C12.5,0,0,12.5,0,28s12.5,28,28,28s28-12.5,28-28S43.5,0,28,0z M28,54C13.6,54,2,42.4,2,28S13.6,2,28,2 s26,11.6,26,26S42.4,54,28,54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.6,31H21.2c-0.7,0-1.4-0.6-1.4-1.4V15.3c0-0.7,0.6-1.4,1.4-1.4h2v-1.6h1.6V14h2.6v-1.6h1.7V14h2.6v-1.6h1.7 V14h1.3c0.7,0,1.4,0.6,1.4,1.4v14.3C36,30.3,35.4,31,34.6,31z M21.2,15.1c-0.1,0-0.2,0.1-0.2,0.2v14.3c0,0.1,0.1,0.2,0.2,0.2h13.5 c0.1,0,0.2-0.1,0.2-0.2V15.3c0-0.1-0.1-0.2-0.2-0.2H21.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.9,39.1c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6S25,39.1,25.9,39.1 M25.9,37.9 c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8C28.8,39.1,27.5,37.9,25.9,37.9L25.9,37.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,16.3c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6C12.1,17.1,12.8,16.3,13.7,16.3  M13.7,15.1c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8S15.3,15.1,13.7,15.1L13.7,15.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,30.6c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6C10.6,31.4,11.3,30.6,12.2,30.6  M12.2,29.4c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8C15,30.7,13.8,29.4,12.2,29.4L12.2,29.4z"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "20.1,22.5 15.1,22.5 14.2,20.3 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "20.1,26.9 15.9,26.9 13.7,30.5 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "24.3,30.7 24.3,36.3 25.1,38.6 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,37.1c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6S36.2,37.1,37.1,37.1 M37.1,35.9 c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8C40,37.2,38.7,35.9,37.1,35.9L37.1,35.9z"
  })))), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "32.1,30.7 32.1,36.1 35,37.9 "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,20.8c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6 C42.8,21.6,43.5,20.8,44.4,20.8 M44.4,19.6c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8 C47.2,20.9,46,19.6,44.4,19.6L44.4,19.6z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 35.9,
    y1: 22.5,
    x2: 42.1,
    y2: 22.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.de81e5b428dba08e6bd491c458bc1be0.svg";
export { ForwardRef as ReactComponent };